import React, { useState } from 'react';
import SaveSearchButton from '@components/catalog/save-search-button/save-search-button';
import Button from '@components/atoms/button/button';
import Icon from '@components/atoms/icon/icon';
import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';
import { useTranslation } from 'next-i18next';
import useFocusFirstProduct from '@hooks/catalog-product/use-focus-first-product';
import styles from './catalog-save-searches-row.module.scss';

const CatalogSaveSearchesRow = () => {
  const [alertError, setAlertError] = useState<string>('');
  const filterChips = useContextSelector(CatalogContext, (v) => v.filterChips);
  const removeAllFilters = useContextSelector(CatalogContext, (v) => v.removeAllFilters);
  const showClearFiltersButton = filterChips && filterChips.length > 0;
  const { t } = useTranslation();

  const triggerFocusOnNextUpdate = useFocusFirstProduct();

  const handleClearFilters = () => {
    // Clear filters (this will remove the button from DOM)
    removeAllFilters();
    triggerFocusOnNextUpdate();
  };

  return (
    <>
      <div className={styles.catalogSaveSearches}>
        <SaveSearchButton
          setAlertError={setAlertError}
          customClassName={styles.catalogSaveSearches__saveSearchButton}
        />
        {showClearFiltersButton && (
          <Button
            key="clear-filter"
            disableDefaultStyling
            className={styles.catalogSaveSearches__clearFilters}
            onClick={handleClearFilters}
            aria-label={t('CATALOG.FILTERS.CLEAR')}
          >
            <Icon
              name="cross-x"
              ariaHidden
            />
            {t('CATALOG.FILTERS.CLEAR')}
          </Button>
        )}
      </div>
      {alertError && <div className={styles.catalogSaveSearches__alertError}>{alertError}</div>}
    </>
  );
};

export default CatalogSaveSearchesRow;
